export default "__VITE_ASSET__BQ8I67bS__"